export default __webpack_public_path__ + "static/about-us-03-51d53645d506d0972822fbf49a433fee.jpg";